import { FC } from 'react';
import { MBox, MFlex, MText } from '../../../../components/Monetize';

const STATUS_MAP: Record<string, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ARCHIVED: 'Archived',
  CANCELED: 'Canceled',
};

interface ItemWithStatusProps {
  name: string;
  entityId: string;
  status: string;
}

export const ItemWithStatus: FC<ItemWithStatusProps> = ({
  name,
  entityId,
  status,
}) => {
  return (
    <MBox w="100%" ml={2} pr={1}>
      <MText fontWeight="medium">{name}</MText>
      <MFlex w="100%" justify="space-between">
        <MText fontSize="xs" color="tGray.darkPurple">
          {entityId}
        </MText>
        <MText fontSize="xs" color="tGray.darkPurple">
          {STATUS_MAP[status] || status}
        </MText>
      </MFlex>
    </MBox>
  );
};
